import React from 'react';
import { HeaderExtensionType } from './types';
import DownloadButtons, {
  DownloadButtonsProps,
} from '../../download-buttons/DownloadButtons';

interface Props<T> extends DownloadButtonsProps<T> {
  headerExtension: HeaderExtensionType;
}

function HeaderExtension<T>({
  headerExtension,
  columns,
  rows,
  fileName,
  onClickDownload,
  isLandscapeOrientation,
  downloadLoading,
}: Props<T>) {
  return (
    <div className="d-flex justify-content-between align-items-center bg-white border-bottom px-12 py-8 gap-10 flex-wrap">
      {headerExtension?.leftComponents ? (
        <div className="grow-1">{headerExtension?.leftComponents}</div>
      ) : (
        <div />
      )}
      <div className="d-flex gap-6">
        {headerExtension?.rightComponents}
        {fileName ? (
          <DownloadButtons
            fileName={fileName}
            columns={columns}
            rows={rows}
            onClickDownload={onClickDownload}
            isLandscapeOrientation={isLandscapeOrientation}
            downloadLoading={downloadLoading}
          />
        ) : null}
      </div>
    </div>
  );
}

export default HeaderExtension;
